import { render, staticRenderFns } from "./UsersLogs.vue?vue&type=template&id=3eb8006a&"
import script from "./UsersLogs.vue?vue&type=script&lang=js&"
export * from "./UsersLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports